/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';
import { Link } from '@scentregroup/shared/link';
import CallToAction from "@scentregroup/ui/components/call-to-action";
import classNames from 'classnames';
import ExternalLink from '../external-link';
import { parsePathname, parseHostname } from '../../helpers/url';
import { GetHrefContext } from '../../context';
import style from './index.module.scss';

// This handles the url check for external link or internal link by matching the hostname
import { jsx as _jsx } from "react/jsx-runtime";
const CallToActionWrapper = _ref => {
  let {
    url,
    category,
    className
  } = _ref;
  const getHref = useContext(GetHrefContext);
  const hostname = parseHostname(getHref());
  if (parseHostname(url) === hostname) {
    return /*#__PURE__*/_jsx(CallToAction, {
      element: Link,
      to: parsePathname(url),
      className: classNames(className, style.callToAction),
      "data-id": "call-to-action-wrapper_index_CallToActionWrapper_CallToAction",
      children: category
    });
  }
  return /*#__PURE__*/_jsx(CallToAction, {
    element: ExternalLink,
    url: url,
    className: classNames(className, style.callToAction),
    "data-id": "call-to-action-wrapper_index_CallToActionWrapper_CallToAction_1",
    children: category
  });
};
export default CallToActionWrapper;